module.exports = __webpack_public_path__ + "img/speaker-GeorgeKipiani.f283ea5d.png";